/**
 * telegram.js — send a Daily Operations list to Telegram via the shared
 * serverless dispatcher (`/api/send-notification`, channel: telegram).
 *
 * The server holds the bot token + chat id (TELEGRAM_BOT_TOKEN / TELEGRAM_CHAT_ID
 * env vars), so nothing secret lives in the client. We pass a UNIQUE alertKey per
 * send so the endpoint's 5-minute per-key rate limit never blocks a manual send,
 * and severity:'high' so it isn't dropped as low-priority.
 */

import { NOTIFY_API_BASE } from '../config/constants';

export async function sendToTelegram(title, body) {
  const res = await fetch(`${NOTIFY_API_BASE}/api/send-notification`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      alertKey: `dailyops_${Date.now()}`,   // unique → bypasses the 5-min rate limit
      title,
      body,
      severity: 'high',
      channels: ['telegram'],
      fcmTokens: [],
    }),
  });

  let data = {};
  try { data = await res.json(); } catch { /* non-JSON response */ }
  if (!res.ok) throw new Error(`Server error ${res.status}`);
  if (data.skipped) {
    throw new Error(data.reason === 'rate_limited' ? 'Just sent — try again in a moment' : 'Message was skipped');
  }
  const tg = data && data.results && data.results.telegram;
  if (!tg || tg.ok === false) {
    throw new Error((tg && tg.error) || 'Telegram is not configured on the server');
  }
  return data;
}
